import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getCurrentSessionUser, getOrganizationId } from '@/data/store/selectors';

export const AdminGuard: React.FC = () => {
  const user = useSelector(getCurrentSessionUser);
  const organizationId = useSelector(getOrganizationId);

  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  // Note: the backend returns 'developer' field according to requirements
  if ((user as any).developer !== true) {
    return <Navigate to={organizationId ? '/dashboard' : '/organizations'} replace />;
  }

  return <Outlet />;
};
